import { USER_PROFILE_FETCH_REQUEST, USER_PROFILE_FETCH_SUCCESS, USER_PROFILE_FETCH_FAILURE } from './types';
import baseUrl from '../../url';

const fetchUserLoginRequest = () => {
    return {
        type: USER_PROFILE_FETCH_REQUEST
    }
}

const fetchUserLoginSuccess = user => {
    return {
        type: USER_PROFILE_FETCH_SUCCESS,
        payload: user,
    }
}

const fetchUserLoginFailure = error => {
    return {
        type: USER_PROFILE_FETCH_FAILURE,
        payload: error,
    }
}

export const getProfile = (query) => {
        return (dispatch) => {
                dispatch(fetchUserLoginRequest());
                const token = localStorage.getItem('token');
                // console.log("Profile Action : ", query);
                fetch(`${baseUrl}/users/me${query !== "" ? `?${query}` : ``}`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then((response) => {
                dispatch(fetchUserLoginSuccess(response))
            })
            .catch((error) => {
                dispatch(fetchUserLoginFailure(error.message));
            })
    }
}